import { useState } from "react";
import { Link } from "react-router-dom";
import PortalLayout from "../../components/PortalLayout";
import { useI18n } from "../../i18n/LanguageContext";
import { sanitizedHtml } from "../../lib/sanitize";
import { FAQ } from "./exploreContent";

export default function ExploreFaqPage() {
  const { locale, t } = useI18n();
  const c = FAQ[locale] || FAQ.it;
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <PortalLayout>
      <section
        className="max-w-[920px] mx-auto px-6 sm:px-8 pt-14 pb-8"
        data-testid="explore-faq-page"
      >
        <Link
          to="/explore"
          className="font-mono-fin text-[0.7rem] tracking-[0.2em] uppercase text-[color:var(--br-bronze-soft)] hover:text-[color:var(--br-bronze)]"
          data-testid="explore-back-link"
        >
          {t("explore.back")}
        </Link>

        <div className="br-fade-up mt-7">
          <div className="br-overline">{c.eyebrow}</div>
          <h1 className="font-serif-display text-[clamp(2.4rem,4.5vw,3.8rem)] mt-3 leading-[1.05]">
            {c.title}
          </h1>
          <p className="text-[1.02rem] text-[color:var(--br-text)] mt-5">{c.sub}</p>
        </div>

        <div className="mt-10 space-y-3 br-fade-up br-delay-1" data-testid="faq-list">
          {c.items.map((item, i) => {
            const isOpen = i === openIdx;
            return (
              <div
                key={i}
                className="br-card overflow-hidden"
                data-testid={`faq-item-${i}`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  className="w-full text-left px-7 py-5 flex items-center gap-5 transition-colors"
                  style={{ background: isOpen ? "rgba(167,128,73,0.05)" : "transparent" }}
                  data-testid={`faq-toggle-${i}`}
                >
                  <span
                    className="font-mono-fin text-[0.7rem] tracking-[0.22em] flex-shrink-0 w-7"
                    style={{ color: "var(--br-bronze)" }}
                  >
                    {item.n}
                  </span>
                  <span className="font-serif-display text-[1.15rem] text-[color:var(--br-parchment)] flex-1 leading-snug">
                    {item.q}
                  </span>
                  <span
                    className="font-mono-fin text-[1.2rem] flex-shrink-0 transition-transform duration-300"
                    style={{
                      color: "var(--br-bronze)",
                      transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                    }}
                  >
                    +
                  </span>
                </button>
                {isOpen && (
                  <div
                    className="px-7 pb-6 text-[0.95rem] text-[color:var(--br-text)] leading-relaxed"
                    style={{ paddingLeft: "calc(28px + 1.75rem)" }}
                    {...sanitizedHtml(item.a)}
                  />
                )}
              </div>
            );
          })}
        </div>
      </section>
    </PortalLayout>
  );
}
